<template>
  <div>

    <b-row>
      <b-col>
        <b-button v-b-modal.supplydetail class="ml-2 btn-pill" size="sm" variant="primary">
          <i class="fa fa-plus"></i> Agregar detalle
        </b-button>
      </b-col>
    </b-row>


    <b-modal
      id="supplydetail"
      ref="modal"
      @ok="handleOk"
      title="Agregar detalle de materiales">
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-row>
          <b-col>
            <b-form-group label="Material">
              <v-select
                :options="supplies"
                label="text"
                :state="$v.supplyDetailData.supply.$dirty ? !$v.supplyDetailData.supply.$error : null"
                v-model="$v.supplyDetailData.supply.$model"
                :reduce="text => text.value"
                class="style-chooser ">
              </v-select>
            </b-form-group>
            <b-form-group label="Cantidad">
              <b-form-input
                type="text"
                id="quantity"
                :state="$v.supplyDetailData.quantity.$dirty ? !$v.supplyDetailData.quantity.$error : null"
                v-model="$v.supplyDetailData.quantity.$model"
                placeholder="ej. 1234"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </form>
    </b-modal>

    <b-modal
      id="barcodemodal"
      ref="barcodemodal"
      size="sm"
      @ok="handleOk"
      title="Agregar detalle de materiales">
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-row>
          <b-col>
            <b-form-group label="Cantidad">
              <b-form-input
                type="text"
                autofocus
                id="quantity"
                :state="$v.supplyDetailData.quantity.$dirty ? !$v.supplyDetailData.quantity.$error : null"
                v-model="$v.supplyDetailData.quantity.$model"
                placeholder="ej. 1234"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </form>


    </b-modal>


  </div>
</template>

<script>

  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css';
  import {required, integer, minLength, between} from 'vuelidate/lib/validators'
  import {bus} from "../../main";
  import miniToastr from 'mini-toastr'

  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  };

  miniToastr.init({types: toastTypes});

  export default {
    name: "SupplyDetailForm",
    props: ['supplyDetailData', 'waybillID', 'items', 'waybillType'],
    components: {
      vSelect
    },
    validations: {
      supplyDetailData: {
        quantity: {required, integer},
        supply: {required}
      }
    },
    methods: {
      onEnter () {
        alert('Hola')
      },
      onBarcodeScanned (barcode) {
        this.supplyDetailData.supply_lot = barcode;
        var arrBarcode = barcode.split('-');
        console.log(arrBarcode.slice(-1)[0]);
        this.supplyDetailData.supply = this.supplies.find(x => x.code === arrBarcode.slice(-1)[0]).value;
        this.$nextTick( () => {
            this.$refs['barcodemodal'].show()
          }
        )

      },
      // Reset to the last barcode before hitting enter (whatever anything in the input box)
      resetBarcode () {
        let barcode = this.$barcodeScanner.getPreviousCode()
        // do something...
      },
      cleanForm() {
        this.supplyDetailData.supply = null;
        this.supplyDetailData.quantity = null;
        this.supplyDetailData.supply_lot = '';
        this.supply_detail_id = null;
      },
      status(validation) {
        return {
          error: validation.$error,
          dirty: validation.$dirty
        }
      },
      handleOk(bvModalEvt) {
        // Prevent modal from closing
        bvModalEvt.preventDefault();
        // Trigger submit handler
        this.handleSubmit()
      },
      handleSubmit() {
        this.$v.$touch();
        if (this.$v.$invalid) {
          return
        }
        this.saveDetail();
        this.$nextTick(() => {
          this.$refs.modal.hide();
          this.$refs['barcodemodal'].hide();
          this.cleanForm()
        })
      },
      saveDetail() {
        if(this.supply_detail_id) {
          this.$axios({
            method: this.axios_method,
            url: this.url,
            data: {
              waybill: this.waybillID,
              supply: this.supplyDetailData.supply,
              quantity: this.quantitySign,
              supply_lot: this.supplyDetailData.supply_lot,
            }
          })
            .then(res => {
              miniToastr.success("Detalle de guía editado con éxito", "");
              this.items.splice(this.supply_detail_index, 1);
              this.items.push(res.data);
            })
            .catch(error => {
              miniToastr.error(error.response.data, "");
              console.log(error)
            });
        } else {
          this.$axios({
            method: this.axios_method,
            url: this.url,
            data: {
              waybill: this.waybillID,
              supply: this.supplyDetailData.supply,
              quantity: this.quantitySign,
              supply_lot: this.supplyDetailData.supply_lot,
            }
          })
            .then(res => {
              miniToastr.success("Detalle de guía creado con éxito", "");
              this.items.push(res.data);
            })
            .catch(error => {
              miniToastr.error(error.response.data, "");
              console.log(error)
            });
        }


      },
      getSupplies() {
        this.supplies = [{id: '', name: 'Cargando...'},];
        this.$axios
          .get("/api/supplies/supply/select_input/")
          .then(res => {
            const data = res.data;
            const supplies = [];
            for (let key in data) {
              const company = data[key];
              supplies.push(company);
            }
            this.supplies = supplies;
          })
          .catch(error => console.log(error));
      },
    },
    computed: {
      quantitySign(){
        return this.waybillType == '4' ? Math.abs(this.supplyDetailData.quantity) * -1 : this.supplyDetailData.quantity;
      },
      url () {
        return this.supply_detail_id ? '/api/supplies/waybill-supply/'+this.supply_detail_id+'/'
          : '/api/supplies/waybill-supply/';
      },
      axios_method () {
        return this.supply_detail_id ? 'put' : 'post'
      }
    },
    data() {
      return {
        supplies: [{id: '', name: 'Cargando...'},],
        supply_detail_id : null,
        supply_detail_index : null,
      }
    },
    created() {
      this.getSupplies();
      this.$barcodeScanner.init(this.onBarcodeScanned);

      bus.$on('editSupplyDetail', (data) => {
        this.supplyDetailData.supply = data.supply;
        this.supplyDetailData.quantity = data.quantity;
        this.supplyDetailData.supply_lot = data.supply_lot;
        this.supply_detail_id = data.id;
        this.supply_detail_index = this.items.indexOf(data);

        this.$nextTick(() => {
          this.$refs.modal.show()
        });
        this.$v.$touch();
      });
    },
    // destroyed() {
    //   this.$barcodeScanner.destroy()
    // },

  }
</script>

<style >
  .style-chooser .vs__search::placeholder,
  .style-chooser .vs__dropdown-toggle,
  .style-chooser .vs__dropdown-menu {
    /*display: inline-block;*/
    /*width: 100%;*/
    min-height: calc(1.5em + 0.75rem + 2px);
    /*padding: 0.375rem 1.75rem 0.375rem 0.75rem;*/
    font-size: 0.6875rem;
    font-weight: 400;
    /*line-height: 1.5;*/
    color: #5c6873;
    /*vertical-align: middle;*/
    /*background-color: #fff;*/
    border: 1px solid #e4e7ea;
    /*border-radius: 0.25rem;*/
    /*-webkit-appearance: none;*/

  }

  .style-chooser .vs__selected {
    color: #5c6873;
  }

  .style-chooser .vs__clear,
  .style-chooser .vs__open-indicator {
    fill: #394066;
  }
</style>
